import { MINNESOTA_LMI_FUNNEL_ID } from '~/funnels/minnesota-lmi/config';
import { LDClient, LDFlags } from '~/providers';
import { fetchVnmTerms } from '~/services';
import { ContractTag } from '~/typings/graphql';

interface FetchTermsBaseParams {
  stateId: number;
  utilityAccountId: number;
  contractTags?: ContractTag[];
  signedContractIds?: (number | null)[];
  funnelId?: string;
}

export const fetchTermsBase = async ({
  stateId,
  utilityAccountId,
  contractTags,
  signedContractIds = [],
  funnelId,
}: FetchTermsBaseParams) => {
  const {
    docuSignContracts,
    showLmi: showLmiFromTerms,
    generalContracts,
    vnmSolarProjectContracts,
  } = await fetchVnmTerms({
    stateId,
    utilityAccountId,
    ...(contractTags ? { contractTags } : {}),
  });

  const allSolarContracts = generalContracts
    ? vnmSolarProjectContracts?.concat(generalContracts)
    : vnmSolarProjectContracts;

  const unsignedSolarContracts = allSolarContracts?.filter(
    contractVersion => !signedContractIds.includes(contractVersion.contractId),
  );

  let updatedUnsignedSolarContracts = unsignedSolarContracts;

  // FOR MN LMI FUNNEL
  if (funnelId === MINNESOTA_LMI_FUNNEL_ID) {
    updatedUnsignedSolarContracts = unsignedSolarContracts.filter(
      contractVersion => contractVersion.tag === ContractTag.MnLmi,
    );
    // Remove the usage request form from the list
    updatedUnsignedSolarContracts = updatedUnsignedSolarContracts.filter(
      contractVersion => contractVersion.contractType !== 'usage_request',
    );
  }

  return {
    docuSignContracts,
    unsignedSolarContracts: updatedUnsignedSolarContracts,
    showLmiFromTerms: showLmiFromTerms && isSatisfyingDefaultLmiRules(stateId),
  };
};

export const isSatisfyingDefaultLmiRules = (stateId: number) => {
  const lmiSelfAttestationStates = LDClient.variation(LDFlags.lmiSelfAttestationState);
  return lmiSelfAttestationStates.includes(stateId);
};
